<mat-toolbar color="primary" [@toolbarState]="toolbarState" [style.pointer-events]="toolbarState === 'visible' ? 'auto' : 'none'"  class="accesible-buttons">
  <nav aria-label="Main navigation">
    <ul id="main-nav">
      @for (item of navigation; track item) {
        <li
          mat-button class="nav-button"
          routerLinkActive="active">
          @if (item.children!==undefined && item.children.length > 0) {
            <span>
              <button mat-button [matMenuTriggerFor]="childMenu" (click)="!showSubmenu = showSubmenu" [ngClass]="{'active' : showSubmenu}" >
                {{item.label | translate}}
                <span class="material-icons">expand_more</span>
              </button>
              <mat-menu
                #childMenu="matMenu" [overlapTrigger]="false">
                <anms-child-menu (clickMenuEvent)="onNavigationClick($event)" [type]=item.type></anms-child-menu>
                <p class="view-all-label"><a [routerLink]="[item.link]"
                  (click)="onNavigationClick()">
                  View all
                  {{item.label | translate}}
                </a></p>
              </mat-menu>
            </span>
          }
          @if (!item.children || item.children.length === 0) {
            <span
              (click)="onNavigationClick()"
              >
              <button mat-button  [routerLink]="item.link">
                {{item.label | translate}}
              </button>
            </span>
          }
        </li>
      }
    </ul>

  </nav>
</mat-toolbar>
